<template>
  <fa-icon icon="flag" />
</template>
